import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { IoAddOutline } from "react-icons/io5";
import { MdDeleteForever } from "react-icons/md";
import { AxiosResponse } from "axios";
import { Modal, Button } from "rsuite";
import { axiosGet, axiosPost, axiosGetParams } from "../../common/utils/helper";
import { EPInputNumber } from "../../common/controls/inputNumber";
import { EPSelectPicker } from "../../common/controls/selectPicker";
import {
  getAllEmployee,
  addRecruiters,
  getRecruitersByRequirementId,
  getRecruiterData,
} from "../../common/utils/api";
import { toast } from "react-toastify";
import "./manageRequest.scss";
import { CommonConstants } from "../../common/utils/CommonConstants";
import Loader from "../Loader/loader";
// import "./assignRecruitersModal.scss";
interface Props {
  open: boolean;
  setOpen: Function;
  RequirementId: number;
  noOfRequirement: number;
  setLoading: any;
}

interface RecruiterObject {
  RecruiterId: string | null;
  RecruiterPosition: string | null;
}
interface element {
  RecruiterPosition: string;
}

interface ReqBody {
  RequirementId: number;
  recruiters: RecruiterObject[];
}

function AssignRecruitersModal(props: Props) {
  const { open, setOpen, RequirementId, noOfRequirement, setLoading } = props;
  const recruiterObject = {
    RecruiterId: null,
    RecruiterPosition: null,
  };
  const [recruiters, setRecruiters] = useState<RecruiterObject[]>([]);
  const [recruiterList, setRecruiterList] = useState([]);
  const [isValidate, setIsValidate] = useState<boolean>();

  useEffect(() => {
    getEmployeeList(getRecruiterData);
    setRecruiters([recruiterObject]);
    getRecruitersByRequirement(getRecruitersByRequirementId);
  }, []);

  async function getEmployeeList(reqUrl: string) {
    const response = (await axiosGet(reqUrl, {})) as AxiosResponse;
    setRecruiterList(response.data.data);
  }

  async function getRecruitersByRequirement(reqUrl: string) {
    const response = (await axiosGetParams(
      `${reqUrl}/${RequirementId}`
    )) as AxiosResponse;
    if (response.data.data.length > 0) setRecruiters(response.data.data);
  }

  const addRecruiter = () => {
    setRecruiters([...recruiters, recruiterObject]);
  };

  const removeRecruiter = (index: number) => {
    const newArray = [...recruiters];
    newArray.splice(index, 1);
    setRecruiters(newArray);
  };

  const handleChange = (value: string, index: number, name: string) => {
    let data: RecruiterObject[] = [...recruiters];
    if (name === "RecruiterId") {
      data[index] = { ...data[index], [name]: value };
    } else {
      data[index] = { ...data[index], [name]: parseInt(value) };
    }
    setRecruiters(data);
  };

  const handleClose = () => {
    setOpen(false);
    setRecruiters([]);
  };

  const hasUniqueCombination = () => {
    const uniqueSet = new Set(
      recruiters.map((obj: RecruiterObject) => obj.RecruiterId)
    );
    if (uniqueSet.size !== recruiters.length) {
      if (uniqueSet.has(null)) return true;
      else return false;
    } else return true;
  };

  const handleSubmit = () => {
    setIsValidate(true);
    if (
      Validate(recruiters) &&
      recruiters.length > 0 &&
      recruiters.length < 6 &&
      hasUniqueCombination() &&
      compareTotalPositionAndTotalRequirement()
    ) {
      const postData = {
        RequirementId,
        recruiters,
      };
      postAddRecruiter(addRecruiters, postData, RequirementId);
    } else {
      if (!hasUniqueCombination()) {
        toast.error("Recruiter already exists", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
      if (!Validate(recruiters)) {
        toast.error("Please enter the required field", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  const Validate = (arr: RecruiterObject[]) => {
    return arr.every((obj: RecruiterObject) =>
      Object.values(obj).every(
        (val) => val !== undefined && val !== "" && val !== null
      )
    );
  };

  const compareTotalPositionAndTotalRequirement = () => {
    let totalPosition: number = 0;
    recruiters.forEach((element: RecruiterObject) => {
      if (element.RecruiterPosition)
        totalPosition = totalPosition + parseInt(element.RecruiterPosition);
    });
    if (totalPosition <= noOfRequirement) return true;
    else {
      toast.error(
        "The total number of requests does not match the total number of positions",
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
      return false;
    }
  };

  const postAddRecruiter = async (
    reqUrl: string,
    reqBody: ReqBody,
    id: number
  ) => {
    setLoading(true);
    const response = (await axiosPost(reqUrl, reqBody)) as AxiosResponse;
    if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
      setLoading(false);
      toast.success("Recruiter has been successfully assigned.", {
        position: toast.POSITION.TOP_CENTER,
      });
      handleClose();
    }
  };

  function handleModalKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Enter") {
      handleSubmit();
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        className="modal-sm"
        backdrop="static"
        keyboard={false}
        onKeyDown={handleModalKeyDown}
      >
        <Modal.Header closeButton={true}>
          Assign Recruiter
          <Button
            type="button"
            className="add-btn float-end me-5"
            onClick={addRecruiter}
            disabled={recruiters.length >= 5 ? true : false}
          >
            <IoAddOutline size={20} />
            Add
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs="7" lg="7" className="recruiter-label">
              Recruiter<span className="req">*</span>
            </Col>
            <Col xs="4" lg="4" className="recruiter-label">
              No. of Position<span className="req">*</span>
            </Col>
            <Col xs="1" lg="1"></Col>
          </Row>
          {recruiters.length > 0 &&
            recruiters.map((recruiter: RecruiterObject, index: number) => {
              return (
                <Row className="mb-3" key={index}>
                  <Col xs="7" lg="7">
                    <EPSelectPicker
                      isValidate={isValidate}
                      label="Recruiter"
                      data={recruiterList}
                      onChange={(val: string) =>
                        handleChange(val, index, "RecruiterId")
                      }
                      value={recruiter?.RecruiterId}
                    />
                  </Col>
                  <Col xs="4" lg="4">
                    <EPInputNumber
                      isValidate={isValidate}
                      value={recruiter?.RecruiterPosition}
                      placeholder="No. of position"
                      min={1}
                      max={1000}
                      onChange={(val: string) =>
                        handleChange(val, index, "RecruiterPosition")
                      }
                    />
                  </Col>
                  <Col xs="1" lg="1">
                    {recruiters.length > 1 && (
                      <Button
                        type="button"
                        className="btn-delete d-inline-block float-end"
                        onClick={() => removeRecruiter(index)}
                      >
                        <MdDeleteForever color="red" size={24} />
                      </Button>
                    )}
                  </Col>
                </Row>
              );
            })}
        </Modal.Body>
        <Modal.Footer className="pt-3">
          <Row>
            <Col xs lg>
              <Button
                type="button"
                onClick={() => handleSubmit()}
                className="btn btn-primary"
              >
                Assign
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AssignRecruitersModal;
